import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";
import WhatsAppButton from "./WhatsAppButton";
import { useRadio } from "@/context/RadioContext";
import { Radio, Volume2, VolumeX, Play } from "lucide-react";

const Layout = () => {
  const location = useLocation();
  const { currentTrack, isPlaying, togglePlay, needsUserInteraction } = useRadio();
  const isHomePage = location.pathname === "/";

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      {/* Mini Radio Player - shows on all pages except home */}
      {!isHomePage && (
        <div className="sticky top-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-lg border-b border-white/10">
          <div className="max-w-lg mx-auto px-3 py-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className={`p-1.5 rounded-lg ${isPlaying ? "bg-[#D946EF] animate-pulse" : "bg-[#1E1E1E]"}`}>
                  <Radio className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-bold truncate" style={{
                    background: 'linear-gradient(90deg, #FFD700, #DAA520)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}>Radio LEYBA</p>
                  {currentTrack ? (
                    <p className="text-[10px] text-gray-400 truncate">
                      {currentTrack.title} - {currentTrack.artist_name}
                    </p>
                  ) : (
                    <p className="text-[10px] text-gray-400 truncate">
                      🎵 24/7 Música
                    </p>
                  )}
                </div>
              </div>
              <button
                onClick={togglePlay}
                className={`p-2 rounded-full transition-all ${
                  needsUserInteraction
                    ? "bg-[#22C55E] hover:bg-[#22C55E]/80 animate-pulse"
                    : isPlaying 
                      ? "bg-[#D946EF] hover:bg-[#D946EF]/80" 
                      : "bg-[#22C55E] hover:bg-[#22C55E]/80"
                }`}
              >
                {needsUserInteraction ? (
                  <Play className="w-4 h-4" />
                ) : isPlaying ? (
                  <VolumeX className="w-4 h-4" />
                ) : (
                  <Volume2 className="w-4 h-4" />
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <main className="pb-safe">
        <Outlet />
      </main>
      <BottomNav />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
